import React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  Select as MuiSelect,
} from "@mui/material";
import { KeyboardArrowDownRounded } from "@mui/icons-material";

export default function Select(props) {
  const {
    name,
    label,
    value,
    variant,
    onChange,
    options,
    required,
    fullWidth = true,
    error = null,
    showNA = false,
    ...other
  } = props;

  return (
    <FormControl
      variant={variant || "outlined"}
      fullWidth={fullWidth}
      required={required}
      sx={{
        "& .MuiFilledInput-root::before": {
          borderBottom: `1px solid var(--grayMD-color)`,
        },
      }}
      {...other}
    >
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        label={label}
        name={name}
        value={options.some((j) => j.id === value) ? value : ""}
        onChange={onChange}
        MenuProps={{
          PaperProps: {
            className: "bg-white",
            sx: { borderRadius: "10px" },
          },
        }}
        renderValue={(selected) => {
          const selectedOption = options.find(
            (option) => option.id === selected
          );
          return selectedOption ? selectedOption.label : "";
        }}
        IconComponent={(e) => <KeyboardArrowDownRounded {...e} />}
        {...(error && { error: true })}
      >
        {showNA && (
          <MenuItem value="">
            <em>N/A</em>
          </MenuItem>
        )}
        {options.map((item, index) => (
          <MenuItem key={index} value={item.id}>
            <ListItemText
              primary={item.label}
              secondary={item.subtitle || ""}
            />
          </MenuItem>
        ))}
      </MuiSelect>
      {error && (
        <FormHelperText className="error-color">{error}</FormHelperText>
      )}
    </FormControl>
  );
}
